function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 660 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3.12161,0.579796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-49.051,0.00856529)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-17.5825,-0.268463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M505.21,66.08L548.47,66.08L548.47,78L491,78L491,66.08M491,13.29L491,1.36L547,1.36L547,13.29L505.21,13.29",
    style: {
      fill: "rgb(207,34,27)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.22,33.22L538.23,33.22L538.23,44.94L501.22,44.94",
    style: {
      fill: "rgb(207,34,27)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-0.188275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.73,1.1L411.39,1.1C418.96,0.956 426.459,2.593 433.28,5.88C439.434,8.862 444.594,13.566 448.13,19.42C451.726,25.527 453.555,32.515 453.41,39.6C453.555,46.685 451.726,53.673 448.13,59.78C444.59,65.628 439.432,70.328 433.28,73.31C426.46,76.6 418.961,78.241 411.39,78.1L377.73,78.1L377.73,1.1ZM410.73,66C415.884,66.11 420.99,64.996 425.63,62.75C429.776,60.724 433.224,57.506 435.53,53.51C437.906,49.266 439.105,44.463 439,39.6C439.103,34.734 437.905,29.928 435.53,25.68C433.218,21.688 429.772,18.472 425.63,16.44C420.988,14.202 415.882,13.091 410.73,13.2L392,13.2L392,66L410.73,66Z",
    style: {
      fill: "rgb(207,34,27)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-32.6053,-0.188565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M596.67,76.67C591.143,74.983 586.763,72.747 583.53,69.96L588.53,58.85C592.007,61.534 595.912,63.613 600.08,65C604.521,66.546 609.188,67.344 613.89,67.36C619.61,67.36 623.88,66.443 626.7,64.61C629.32,63.138 630.945,60.355 630.94,57.35C630.999,55.273 630.129,53.274 628.57,51.9C626.826,50.376 624.782,49.235 622.57,48.55C620.15,47.743 616.85,46.827 612.67,45.8C607.835,44.714 603.075,43.318 598.42,41.62C594.808,40.218 591.599,37.944 589.08,35C586.48,32.033 585.18,28.033 585.18,23C585.142,18.871 586.348,14.825 588.64,11.39C591.247,7.671 594.877,4.787 599.09,3.09C603.75,1.03 609.453,0 616.2,0C620.876,-0 625.533,0.591 630.06,1.76C634.24,2.774 638.219,4.484 641.83,6.82L637.32,17.93C634.008,15.981 630.459,14.465 626.76,13.42C623.291,12.42 619.7,11.902 616.09,11.88C610.437,11.88 606.237,12.833 603.49,14.74C600.892,16.378 599.328,19.259 599.37,22.33C599.31,24.388 600.177,26.368 601.73,27.72C603.489,29.21 605.53,30.332 607.73,31.02C610.15,31.827 613.45,32.743 617.63,33.77C622.414,34.811 627.119,36.188 631.71,37.89C635.324,39.286 638.549,41.533 641.11,44.44C643.703,47.367 645,51.327 645,56.32C645.039,60.432 643.829,64.461 641.53,67.87C638.9,71.576 635.253,74.442 631.03,76.12C626.363,78.167 620.643,79.193 613.87,79.2C608.043,79.215 602.246,78.363 596.67,76.67Z",
    style: {
      fill: "rgb(207,34,27)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-57.1922,-0.188463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M716.08,45.87L703.87,58.41L703.87,78.1L689.57,78.1L689.57,1.1L703.87,1.1L703.87,40.59L741.93,1.1L758,1.1L725.65,35.53L760,78.1L743.25,78.1L716.08,45.87Z",
    style: {
      fill: "rgb(207,34,27)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-0.18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0.000101925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.52,13.2L0,13.2L0,1.1L65.34,1.1L65.34,13.2L39.82,13.2L39.82,78.1L25.52,78.1L25.52,13.2Z",
    style: {
      fill: "rgb(207,34,27)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-21.1854,0.000101925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.9,1.1L174.9,78.1L160.6,78.1L160.6,45.1L120.78,45.1L120.78,78.1L106.48,78.1L106.48,1.1L120.78,1.1L120.78,32.89L160.6,32.89L160.6,1.1L174.9,1.1Z",
    style: {
      fill: "rgb(207,34,27)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-41.7217,-0.167398)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.00098,0,-0.0763468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.72,66.23L273,66.23L273,78.23L215.46,78.23L215.46,66.23M215.46,13.38L215.46,1.38L271.46,1.38L271.46,13.38L229.72,13.38",
    style: {
      fill: "rgb(207,34,27)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.71,33.34L262.77,33.34L262.77,45.07L225.71,45.07",
    style: {
      fill: "rgb(207,34,27)",
      fillRule: "nonzero"
    }
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d9159576ff46e6b3b00e0d447b1e52d3.svg";
export { ForwardRef as ReactComponent };